import React from 'react';
import {
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

type TravelHistoryCardProps = {
  children?: React.ReactNode;
};

const TravelHistoryCard = ({ children }: TravelHistoryCardProps) => (
  <Card
    sx={{
      bgcolor: 'background.paper',
      borderRadius: '12px',
      border: 'none',
      boxShadow: 'none',
    }}
  >
    <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
      <Stack spacing={3}>
        <Typography variant="h3">Travel History</Typography>

        <Stack spacing={3} divider={<Divider />}>
          {children}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);

export default TravelHistoryCard;
